<template>
  <div
    class="uk-text uk-text-center uk-margin-large-top uk-padding-small uk-padding-remove-horizontal footer"
  >
    &copy; {{ copyright }}
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  data() {
    return {
      copyright: process.env.VUE_APP_COPYRIGHT
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="less" scoped>
@import "../styles/variables.less";

.footer {
  width: 100vw;
  position: absolute;
  bottom: 0;
  color: @color-white;
  background-color: @color-dim-gray;
}
</style>
